import { useTranslations } from 'next-intl';
interface HeaderProps {
	clickClose: () => void;
}
export const Header = ({ clickClose }:HeaderProps) => {
	const t = useTranslations('General');

	return (
		<div className="survey-bar">
			<div className="survey-bar__btn" onClick={clickClose}>
				<i className="survey-bar__icon"></i>
			</div>
			<div className="survey-bar__title">
				{t('lbl_SabaSurveyTitle')} 
			</div>
		</div>
	)
}
 